// AnalyticsTracker.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../utils/analytics/gtag";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const page_path = location.pathname + location.search;
    trackPageView(page_path);
  }, [location]);

  return null;
}
